import IsapreTypeModel from '@/models/HumanResource/HrIsapreType'

import axios from 'axios'
let route = process.env.VUE_APP_API_ROUTE + '/hr_isapre_type'

// const fetch = () => modelo.get()
// const find = (id) => modelo.find('id')

const createIsapreType = async function(data) {
    try {
        let isapreType = new IsapreTypeModel(data)
        let response = await isapreType.save()
        return response
    } catch (error) {
        return error.response.data
    }
}

const deleteIsapreType = async function(id) {
    try {
        let response = await axios.delete(route + '/' + id)
        console.log('Elemento ' + id + ' eliminado')
        return response.data
    } catch (error) {
        return error.response.data
    }
}

const fetchIsapreType = async function(id) {
    try {
        let isapreType = await IsapreTypeModel.find(id)
        return isapreType
    } catch (error) {
        console.log('Error en fetch', error)
        return error.response.data
    }
}

const updateIsapreType = async function(id, data) {
    try {
        let isapreType = await fetchIsapreType(id)
        //-
        isapreType.type = data.type
        //-
        let response = await isapreType.save()
        //-
        return response
    } catch (error) {
        error.response.data
    }
}

const findIsapreByName = async type => {
    try {
        let typeIsapre = await IsapreTypeModel.where('type', type).get()
        return typeIsapre.data
    } catch (error) {
        console.log('Error en find', error)
        return error.response.data
    }
}

export default {
    createIsapreType,
    deleteIsapreType,
    fetchIsapreType,
    updateIsapreType,
    findIsapreByName,
}
